import SaveButton from '@pages/partners-order/footer/SaveButton';



interface FooterProps {
	scrollToTop: () => void
}


const Footer = (props: FooterProps): JSX.Element => {
	const { scrollToTop } = props;
	
	return (
		<div className='footer-section'>

			<p className='gdpr-message'>Odesláním objednávky souhlasíte s&nbsp;obchodními podmínkami a&nbsp;GDPR</p>
			
			<div className='send-button'>
				<SaveButton scrollToTop={scrollToTop} />
			</div>
			
		</div>
	);
};

export default Footer;